module.exports = __webpack_public_path__ + "img/2-4.358023aa.svg";